import { useEffect } from 'react';

function SEO({ title, description, keywords, ogImage, canonical, structuredData }) {
  if (import.meta.env.VITE_DISABLE_SEO === 'true') {
    return null;
  }

  const siteTitle = import.meta.env.VITE_APP_NAME || 'ZipWin';
  const homeTitle = `${siteTitle}官网 - 免费高速压缩解压工具下载`;

  // 统一所有页面的标题格式：当前页面名 | 网站名（标题已含网站名时不重复拼接）
  const fullTitle = (title && title !== '首页')
    ? (title.includes(siteTitle) ? title : `${title} | ${siteTitle}`)
    : homeTitle;

  const defaultDescription = `${siteTitle} 是一款免费高效的压缩解压工具，支持 ZIP、7Z、RAR 等多种格式，秒速压缩解压，一键搞定。下载安装即可使用。`;
  const defaultKeywords = `${siteTitle},压缩软件,解压软件,免费压缩工具,文件压缩`;

  useEffect(() => {
    // Update title
    document.title = fullTitle;

    // Update meta tags
    const metaTags = {
      'description': description || defaultDescription,
      'keywords': keywords || defaultKeywords,
      'og:title': fullTitle,
      'og:description': description || defaultDescription,
      'twitter:title': fullTitle,
      'twitter:description': description || defaultDescription,
    };

    Object.entries(metaTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    });

    // Update canonical URL
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) {
        link.setAttribute('href', canonical);
      }
    }

    // Update OG image if provided
    if (ogImage) {
      const ogImageMeta = document.querySelector('meta[property="og:image"]');
      const twitterImageMeta = document.querySelector('meta[name="twitter:image"], meta[property="twitter:image"]');
      if (ogImageMeta) ogImageMeta.setAttribute('content', ogImage);
      if (twitterImageMeta) twitterImageMeta.setAttribute('content', ogImage);
    }
    
    // Inject structured data (JSON-LD) for better SEO snippets
    if (structuredData) {
      let scriptTag = document.querySelector('#seo-structured-data');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.id = 'seo-structured-data';
        scriptTag.type = 'application/ld+json';
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(structuredData);
    } else {
      // Clean up if not provided on this page
      const scriptTag = document.querySelector('#seo-structured-data');
      if (scriptTag) scriptTag.remove();
    }

  }, [title, description, keywords, ogImage, canonical, fullTitle, structuredData]);

  return null;
}

export default SEO;
